<template>
  <div class="mt16">
    <QS-h4-title title="司机警示金" />
    <el-row>
      <el-col :span="12">
        <el-table :data="driverWarningPayList">
          <el-table-column  prop="totalAmount" label="类型" >
            <template slot-scope="{row}">
              <span>
                {{row.name }}
              </span>
            </template>
          </el-table-column>
          <el-table-column  prop="totalAmount" label="应收金额（元）" >
            <template slot-scope="{row}">
              <span>
                {{row.money }}
              </span>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'driverWarningPay',
  props: ['driverWarningPayList'],
}
</script>

<style>

</style>
